import React, { useEffect, useState } from "react";
import { useTable, useSortBy, usePagination } from "react-table";
import { PrevBtn, NextBtn, PaginationWrapper } from "../Styles/PageStyles";
import Images from "../../Images";
import tw from "tailwind-styled-components";
import moment from "moment";
import Config, { PaginationLimit } from "../../Config";
import { MdComment, MdDelete, MdModeEdit, MdTrendingUp } from "react-icons/md";
import { IoMdEye } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { IoMdMore } from "react-icons/io";
import { GrConfigure, GrUserWorker } from "react-icons/gr";
// import { Tooltip } from "react-tooltip";
import Tooltip from "../Tooltip";
import { FaApple, FaWindows } from "react-icons/fa";
import { DiAndroid } from "react-icons/di";
import { HiOutlineUserAdd } from "react-icons/hi";
import { FaCreditCard } from "react-icons/fa";
import {
  AiOutlineCloudUpload,
  AiTwotoneBank,
} from "react-icons/ai";
import { IoCashOutline, IoCopySharp } from "react-icons/io5";
import { BsGraphUpArrow } from "react-icons/bs";
import { handleCopy } from "../../helpers";

const Table = ({
  ApiData,
  setSelectedData,
  setEditUser,
  setUploadLogo,
  setAddSubAccount,
  setViewDetail,
  userType,
  setConvinceFee,
  setUploadLeads,
  setAddComments,
  setIsDeleteOwner,
}) => {
  const [data, setData] = useState([
    {
      deviceName: "",
      extractionTime: "",
      processingTime: "",
      drops: "",
      action: "",
    },
  ]);
  // console.log(ApiData);
  const navigate = useNavigate();
  const [selectedRow, setSelectedRow] = useState(null);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);
  const [previousId, setPreviousId] = useState(null);
  const [currentPage, setCurrentPage] = useState(0);
  const [openActionMenu, setOpenActionMenu] = useState(null);
  const toggleRow = (index) => {
    setSelectedRow(selectedRow === index ? null : index);
  };

  const edit = (item) => {
    setEditUser(true);
    setSelectedData(item);
    setOpenActionMenu(null);
  };
 
  const addSub = (item) => {
    setAddSubAccount(true);
    setSelectedData(item);
    setOpenActionMenu(null);
  };

  const logo = (item) => {
    setUploadLogo(true);
    setSelectedData(item);
    setOpenActionMenu(null);
  };

  const leads = (item) => {
    setUploadLeads(true);
    setSelectedData(item);
    setOpenActionMenu(null);
  };

  const viewDetail = (item) => {
    setViewDetail(true);
    setSelectedData(item);
    setOpenActionMenu(null);
  };

  const convinceFees = (item) => {
    setConvinceFee(true);
    setSelectedData(item);
    setOpenActionMenu(null);
  };

  const comment =(item) => {
     console.log("clicked", item);
    setAddComments(true);
    setSelectedData(item);
    setOpenActionMenu(null);
  }

  const deleteOwner = (item) => {
    setIsDeleteOwner(true);
    setSelectedData(item);
    setOpenActionMenu(null);
  };

  // const charges = (item) => {
  //   navigate(`/charges/${item.id}`, { state: { name: item.name } });
  // };

  const goToProperties = (item) => {
    navigate(`/properties/${item.id}`, { state: { name: item?.name } });
  };

  const clientconfig=(item) =>{
    navigate(`/clientconfig/${item.id}`, {state:{name:item?.name}})
  }

  const  bank =(item)=>{
    navigate(`/bank/${item.id}`,{state:{name: item?.name}})
  }
  const ActionBtns = (item) => {
    const openMenu = (id) => {
      // console.log("Button clicked, ID:", id);
      setPreviousId(openActionMenu);
      setOpenActionMenu((prevId) => {
        // console.log("Previous open menu ID:", prevId);
        return prevId === id ? null : id;
      });
    };

    return (
      <ActionBtnWrapper>
        {openActionMenu === item.id && (
          <MenuOptions id="menuOptions">
            {userType != Config.userType.MARKETING && (
              <MenuItem title="Edit Details" onClick={() => edit(item)}>
                <MdModeEdit className="text-gray-700 mr-2" />
                Edit Details
              </MenuItem>
            )}
        
            {/* <MenuItem title="logo" onClick={() => leads(item)}>
              <AiOutlineCloudUpload className="text-gray-700 mr-2" />
              Upload Leads
            </MenuItem> */}

            <MenuItem title="View Detail" onClick={() => viewDetail(item)}>
              <IoMdEye className="text-gray-700 mr-2" /> View Detail
            </MenuItem>
            
            {userType != Config.userType.MARKETING && (
              <MenuItem title="Add Sub Account" onClick={() => addSub(item)}>
                <HiOutlineUserAdd  className="text-gray-700 mr-2" />
                Add Sub Account
              </MenuItem>

              
            )}
            <MenuItem title="Client Config" onClick={(e)=>{e.stopPropagation() ; clientconfig(item)}}>
              <GrConfigure className="text-gray-700 mr-2" />Client Config
            </MenuItem>

            <MenuItem 
              title="Add Remark"
              onClick={()=> comment(item)}
            >
              <MdComment className="text-gray-700 mr-2"/>
              Add Remark
            </MenuItem>

            <MenuItem
              title="Revenue"
              onClick={(e) => {
                e.stopPropagation();
                navigate(`/revenue/${item.id}`, {
                  state: {
                    name: item?.name,
                    ownerData: item,
                  },
                });
                setOpenActionMenu(null);
              }}
            >
              <BsGraphUpArrow className="text-gray-700 mr-2" />
              Revenue
            </MenuItem>

             {item.status === 4 && (
              <>
                {/* <MenuItem title="Extra Charges" onClick={() => charges(item)}>
                  <MdOutlineCurrencyRupee className="text-gray-700 mr-2" />{" "}
                  Extra Charges
                </MenuItem> */}

                <MenuItem title="Add Bank" onClick={(e)=>{e.stopPropagation(); bank(item)}}>
                  <AiTwotoneBank className="text-gray-700 mr-2"/>Add Bank
                </MenuItem>
                
                <MenuItem
                  title="Staff"
                  onClick={() =>
                    navigate(`/staff/${item.id}`, {
                      state: { name: item.name },
                    })
                  }
                >
                  <GrUserWorker className="text-gray-700 mr-2" /> Staffs
                </MenuItem>

              </>
            )}

            <MenuItem title="ConvinceFee" onClick={() => convinceFees(item)}>
              <FaCreditCard  className="text-gray-700 mr-2" /> Convince Fee
            </MenuItem>

            <MenuItem title="logo" onClick={() => logo(item)}>
              <AiOutlineCloudUpload className="text-gray-700 mr-2" />
              Upload Logo
            </MenuItem>

            {item.status !== 4 && item.status !== 5 && (
              <MenuItem title="Deactivate Owner" onClick={() => deleteOwner(item)}>
                <MdDelete className="text-gray-700 mr-2" />
                Deactivate Owner
              </MenuItem>
            )}
          </MenuOptions>
        )}
        <Btn title="Actions" type="button" onClick={() => openMenu(item.id)}>
          <IoMdMore className="text-gray-600" size={24} />
        </Btn>
      </ActionBtnWrapper>
    );
  };

  useEffect(() => {
    if (ApiData) {
      const tempData = ApiData.map((item) => ({
        name: getName(item),
        mobile: item.mobile,
        city: getCity(item),
        propCount: propertyCount(item),
        device: getDeviceIcon(item.device),
        date: getDate(item),
        status: getStatus(item.status),
        action: ActionBtns(item),
        holdOutBalance: getAmounts(item),
        createdAt: getCreatedAt(item),
      }));
      setData(tempData);
    }
  }, [ApiData, openActionMenu]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        !event.target.closest("#menuOptions") &&
        !event.target.closest(".action-btn")
      ) {
        setOpenActionMenu(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const getName = (item) => {
    return (
      <div className="flex flex-col gap-[2px]">
        <p
         className="text-zinc-900 font-semibold"
        
        >{item.name}</p>
        <div className="flex items-center gap-1 text-xs text-gray-400">
          <p className="text-amber-500 text-xs">#{item.mobile}</p>
          <button
              onClick={(e) => {
                e.stopPropagation();
                handleCopy(item.mobile);
              }}
              className="hover:text-gray-600 transition"
              title="Copy number"
            >
              <IoCopySharp size={8} />
          </button>
        </div>
      </div>
    );
  };

  // const getCity = (item) => {
  //       const city = item?.city || "N/A"  //usrd to prevent typeerror when city is null null.length give error.
  //       const isLongCityName = city.length > 45;
  //       return (
  //         <div>
  //           <div className="text-gray-500 font-medium text-sm">{item?.propName}</div>
  //           <a
  //             data-tooltip-id={`tooltip-city-${item.id}`}
  //             data-tooltip-content={isLongCityName ? item.city : ""}
  //             data-tooltip-delay-show={1000}
  //             data-tooltip-place="top"
  //             data-tooltip-variant="info"
  //             className="max-w-[150px] text-gray-400 font-medium text-xs"
  //           >
  //             {isLongCityName ? (
  //               <p className="cursor-pointer">
  //                 {item.city.substring(0, 45) + "..."}
  //               </p>
  //             ) : (
  //               item.city
  //             )}
  //           </a>
  //           <Tooltip id={`tooltip-city-${item.id}`} className="!w-60 sm:!w-80" />
  //         </div>
  //       );
  //     };

  const getCity = (item) => {
  const city = item?.city || "";
  const isLongCityName = city.length > 20;

  const displayCity = isLongCityName
    ? city.substring(0, 20) + "..."
    : city;

  if (!isLongCityName) {
    return (
      <div>
        <div className="text-gray-500 font-medium text-sm">
          {item?.propName}
        </div>

        <p className="text-gray-400 font-medium text-xs">
          {city}
        </p>
      </div>
    );
  }

  return (
    <div>
      <div className="text-gray-500 font-medium text-sm">
        {item?.propName}
      </div>

      <Tooltip
        label={
          <div className="text-xs leading-5 max-w-xs">
            {city}
          </div>
        }
      >
        <p className="text-gray-400 font-medium text-xs cursor-pointer w-fit">
          {displayCity}
        </p>
      </Tooltip>
    </div>
  );
};

  // const propertyCount = (item) => {
  //   const isClickable = item.propCount > 0;
  //   const isClickableBeds = 0;
  //   return (
  //     <div className="flex gap">
  //       <div className="flex flex-col ">
  //         <span
  //           className={`${isClickable
  //             ? "cursor-pointer underline font-semibold"
  //             : "cursor-default"
  //             }`}
  //           onClick={() => isClickable && goToProperties(item)}
  //         >
  //           {"#" + item.propCount} </span>
  //       </div>/
  //       <div className="flex flex-col">
  //         <span
  //           className={
  //             isClickableBeds
  //               ? "cursor-pointer underline font-semibold"
  //               : "cursor-default"
  //           }
  //         >
  //           {  item.totalBeds}
  //         </span> 
          
  //       </div>
  //     </div>
  //   );
  // };

  const propertyCount = (item) => {
    const isClickable = item.propCount > 0;
    const isClickableBeds = 0;
    const content = (
      <div className="flex gap">
        <div className="flex flex-col">
          <span
            className={
              isClickable
                ? "cursor-pointer underline font-semibold"
                : "cursor-default"
            }
            onClick={(e) => {
              e.stopPropagation();

              if (item.propCount > 0) {
                goToProperties(item);
              }
            }}
          >
            #{item.propCount || 0}
          </span>
        </div>/
        <div className="flex flex-col">
          <span
            className={
              isClickableBeds
                ? "cursor-pointer underline font-semibold"
                : "cursor-default"
            }
          >
            {item.totalBeds || 0}
          </span>
        </div>
      </div>
    );

    return (
      <Tooltip
        label={
          <div className="text-xs leading-5">
            <div>Total Properties: {item.propCount || 0}</div>
            <div>Total Beds: {item.totalBeds || 0}</div>
            <div>Total Tenants: {item?.tenantCount || 0}</div>
          </div>
        }
      >
        <div className="cursor-pointer w-fit">
          {content}
        </div>
      </Tooltip>
    );
  };

  const getCreatedAt = (item) => {
    return (
      <div className="flex flex-col gap-[2px]">
        <p className="text-gray-500 font-medium text-sm">
          {item.lastLogin
            }
        </p>
        <p className="text-gray-400 font-medium text-xs">
          {item.createdAt
            ? moment(item.createdAt).format("DD-MM-YYYY")
            : "--"}
        </p>
      </div>
    );
  };

  const getAmounts = (item) => {
    
    return (
      <div className="flex gap-3">
        <div className="flex flex-col ">
          <span >
            {item.totalHoldedAmount} </span>
          <span className="text-gray-400 font-medium text-xs"> 
            Holded Amount
          </span>
        </div>
        <div className="flex flex-col">
          <span >
            {item?.holdOutBalance || 0}
          </span>
          <span className="text-gray-400 font-medium text-xs">
           Pending Amount
          </span>
        </div>
      </div>
    );
  };
  
  const getStatus = (status) => {
  if (status == 1) {
    return <Unverified>Unverified</Unverified>;
  } else if (status == 2) {
    return <Verified>Verified</Verified>;
  } else if (status == 3) {
    return <Active>Active</Active>;
  } else if (status == 4) {
    return <Enrolled>Enrolled</Enrolled>;
  } else if (status == 5) {
    return <Default>Defaulter</Default>;
  } else {
    return <Default>Unknown</Default>;
  }
};
  const getDate = (item) => {
    return (
      <div className="flex items-center gap-2">
        {getDeviceIcon(item.device)}
        {moment(item.lastLogin).format("DD-MM-YYYY HH:mm")}
      </div>
    );
  };

  const getDeviceIcon = (device) => {
    switch (device) {
      case 1:
        return <DiAndroid className="text-gray-500 text-lg" />;
      case 2:
        return <FaApple className="text-gray-500 text-lg" />;
      case 3:
        return <FaWindows className="text-gray-500 text-lg" />;
      default:
        return <DiAndroid className="text-gray-500 text-lg" />;
    }
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const columns = React.useMemo(() => {
    if (isMobileView) {
      // Display only "User" column for mobile screens
      return [
        {
          Header: "Owner Name",
          accessor: "name",
        },
        {
          Header: "Property",
          accessor: "propCount",
        },
      ];
    }

    // Columns for larger screens
    return [
      {
        Header: "Owner Details",
        accessor: "name",
      },
      {
        Header: "City",
        accessor: "city",
      },
      {
        Header: "Property/Beds",
        accessor: "propCount",
      },
      {
        Header: "Login/Created",
        accessor: "createdAt",
      },
      {
        Header: "Status",
        accessor: "status",
      },
      {
        Header: "Action",
        accessor: "action",
      },
    ];
  }, [isMobileView]);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    pageOptions,
    page,
    state: { pageIndex, pageSize },
    previousPage,
    nextPage,
    setPageSize,
    canPreviousPage,
    canNextPage,
  } = useTable(
    {
      data,
      columns,
      initialState: { pageIndex: currentPage, pageSize: PaginationLimit },
    },
    useSortBy,
    usePagination
  );

  useEffect(() => {
    setCurrentPage(pageIndex); // Update current page on state change
  }, [pageIndex]);
  return (
    <>
      <CustomTable {...getTableProps()}>
        <Thead>
          {headerGroups.map((headerGroup) => (
            <Tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <Th {...column.getHeaderProps(column.getSortByToggleProps())}>
                  {column.render("Header")}
                  <span>
                    {column.isSorted ? (
                      <img
                        src={Images.Arrow}
                        alt="down arrow"
                        className={`${column.isSortedDesc ? "-rotate-90" : "rotate-90"
                          } w-1.5 inline-block ml-1.5`}
                      />
                    ) : (
                      ""
                    )}
                  </span>
                </Th>
              ))}
            </Tr>
          ))}
        </Thead>
        {/* <Tbody {...getTableBodyProps()} hasdata={ApiData?.length > 0}> */}
        <Tbody
          {...getTableBodyProps()}
          className={ApiData?.length > 0 ? "border-b" : ""}
        >
          {page.map((row, rowIndex) => {
            prepareRow(row);
            return (
              <React.Fragment key={rowIndex}>
                {/* <Tr {...row.getRowProps()} hasdata={ApiData?.length > 0}> */}
                <Tr
                  {...row.getRowProps()}
                  className={ApiData?.length > 0 ? "border-b" : ""}
                >
                  {row.cells.map((cell, cellIndex) => {
                    return (
                      <Td
                        {...cell.getCellProps()}
                        onClick={() => {
                          if (
                            cellIndex === 0 ||
                            (cellIndex === 1 && window.innerWidth < 768)
                          ) {
                            toggleRow(rowIndex);
                          }
                        }}
                      >
                        {cell.render("Cell")}
                      </Td>
                    );
                  })}
                </Tr>
                {selectedRow === rowIndex && window.innerWidth < 768 && (
                  <Tr>
                    <Td colSpan={columns.length}>
                      <ul className="flex flex-col gap-2">
                        <li>
                          <strong>City:</strong> {data[rowIndex].city}
                        </li>
                        <li>
                          <strong>Created At:</strong> {data[rowIndex].date}
                        </li>
                        <li className="flex gap-2">
                          <strong>Status:</strong> {data[rowIndex].status}
                        </li>
                        <li>
                          <strong>Action:</strong> {data[rowIndex].action}
                        </li>
                      </ul>
                    </Td>
                  </Tr>
                )}
              </React.Fragment>
            );
          })}
        </Tbody>
      </CustomTable>
      {ApiData?.length > 0 && (
        <PaginationWrapper>
          <div className="px-2">
            Page{" "}
            <em>
              {pageIndex + 1} of {pageOptions.length}
            </em>
          </div>
          <div className="flex gap-1">
            <PrevBtn onClick={() => previousPage()} disabled={!canPreviousPage}>
              <img src={Images.Arrow} alt="arrow" className="w-2 opacity-75 " />
            </PrevBtn>
            <NextBtn onClick={() => nextPage()} disabled={!canNextPage}>
              <img
                src={Images.Arrow}
                alt="arrow"
                className="w-2 rotate-180 opacity-75 "
              />
            </NextBtn>
          </div>
        </PaginationWrapper>
      )}
    </>
  );
};
const Btn = tw.button`action-btn grid place-items-center border border-gray-300 w-8 h-8 rounded-full transform transition duration-200 hover:scale-110 hover:shadow-md`;
const ActionBtnWrapper = tw.div`flex items-center gap-3 relative`;
const CustomTable = tw.table` w-full text-zinc-600`;
const Thead = tw.thead`border-b uppercase text-zinc-500 bg-slate-100`;
const Tbody = tw.tbody`${({ hasdata }) => (hasdata ? "border-b" : "")}`;
const Tr = tw.tr`${({ hasdata }) =>
  hasdata ? "border-b" : ""} rounded-md overflow-hidden hover:bg-slate-50`;
const Th = tw.th`text-left text-sm md:p-3 p-0.5 font-medium text-gray-500`;
const Td = tw.td`p-3 text-sm md:p-3 text-left`;
const Active = tw.div`bg-green-100 text-green-700 text-xs border-green-300 border w-24 h-7 flex items-center justify-center rounded-full`;
const Verified = tw.div`bg-teal-100 text-teal-700 text-xs border-teal-300 border w-24 h-7 flex items-center justify-center rounded-full`;
const Unverified = tw.div`bg-rose-100 text-rose-700 text-xs border-rose-300 border w-24 h-7 flex items-center justify-center rounded-full`;
const Enrolled = tw.div`bg-yellow-100 text-yellow-700 text-xs border-yellow-300 border w-24 h-7 flex items-center justify-center rounded-full`;
const MenuOptions = tw.div`absolute bottom-10 right-0 py-4 w-max max-h-[345px] bg-white z-50 rounded-lg shadow-lg border border-gray-200 flex flex-col overflow-y-auto`;
const Default = tw.div`bg-red-100 text-red-700 text-xs border-red-300 border w-24 h-7 flex items-center justify-center rounded-full`;
const MenuItem = tw.div`flex items-center gap-2 px-4 py-2 text-base font-medium cursor-pointer hover:bg-gray-100`;
export default Table;